import { faFolderPlus } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { IOrderForm, IOrderFormSaveFn, ISaveOrderResult } from "order/model"
import { closeOrderFormPopup } from "order/tools/form"
import React from "react"
import { connect } from "react-redux"
import { Popup } from "ui/components/Popup"
import { isPhoneScreen } from "ui/tools/responsive"
import { OrderForm } from "./OrderForm"

interface IOrderFormPopupProps extends IOrderFormPopupConnectProps {
  onSave: IOrderFormSaveFn
  isDspDeal: boolean
  id?: string
  sx?: any
}

interface IOrderFormPopupConnectProps {
  isFormOpened: boolean
  form: IOrderForm
  isPhone: boolean
}

const OrderFormPopupFn = React.memo(
  ({ onSave, isFormOpened, isDspDeal, id, form, sx, isPhone }: IOrderFormPopupProps) => {
    if (!isFormOpened) {
      return null
    }
    const onClose = () => closeOrderFormPopup()
    return (
      <Popup
        icon={faFolderPlus}
        id="order-form-popup"
        displayCloseIcon={!form.isSaving}
        title={translate(form.isCreation ? "order.add.title" : "order.update.title")}
        onClose={() => onClose()}
        minWidth={isPhone ? "calc(100% - 2rem)" : "25rem"}
        maxWidth="30rem"
        sx={{
          "& h2.MuiDialogTitle-root": { minWidth: 0 },
          "& h2.MuiDialogTitle-root p": { marginRight: "1rem" },
          ...sx
        }}>
        <OrderForm
          id={id}
          form={form}
          isDspDeal={isDspDeal}
          onSave={(result: ISaveOrderResult) => onSave(result)}
          onCancel={() => onClose()}
        />
      </Popup>
    )
  }
)

export const OrderFormPopup = connect(
  (state: IRootState): IOrderFormPopupConnectProps => ({
    isFormOpened: state.order.isFormPopupOpened,
    form: state.order.form,
    isPhone: isPhoneScreen(state)
  })
)(OrderFormPopupFn)
